<div class="contacts-info">
    <div class="contacts-info-title">{{ TEXTS.LOGIN_WINDOWS.techSup }}</div>
    <div class="contacts-info-details" [innerHTML]="TEXTS.LOGIN_WINDOWS.info"></div>
</div>
